import { Phone, Mail, MapPin } from "lucide-react";
import QuoteForm from "./QuoteForm";

export default function Contact() {
  return (
    <section id="contact" data-testid="contact-section" className="relative py-28 md:py-40 px-6 md:px-10">
      <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-14">
        <div>
          <span className="font-mono-x text-primary text-xs tracking-[0.35em]">/ 09 — GET A QUOTE</span>
          <h2 className="mt-6 font-heading font-extrabold tracking-tighter text-4xl md:text-6xl leading-[0.9]">
            Same day.<br /><span className="text-primary">Your way.</span>
          </h2>
          <p className="mt-6 text-muted-foreground max-w-md">Tell us about your freight and we'll return a transparent, all-in quote — usually within hours.</p>

          <div className="mt-10 space-y-5">
            <a href="tel:+14378082496" data-testid="contact-phone" className="flex items-center gap-4 group">
              <span className="w-11 h-11 rounded-full glass flex items-center justify-center text-primary"><Phone className="w-4 h-4" /></span>
              <span className="group-hover:text-primary transition-colors">+1 (437) 808-2496</span>
            </a>
            <a href="mailto:dispatch@conexarelay.com" data-testid="contact-email" className="flex items-center gap-4 group">
              <span className="w-11 h-11 rounded-full glass flex items-center justify-center text-primary"><Mail className="w-4 h-4" /></span>
              <span className="group-hover:text-primary transition-colors">dispatch@conexarelay.com</span>
            </a>
            <div className="flex items-center gap-4">
              <span className="w-11 h-11 rounded-full glass flex items-center justify-center text-primary"><MapPin className="w-4 h-4" /></span>
              <span>Control Tower — Milton, ON · Canada</span>
            </div>
          </div>

          <div className="mt-8 rounded-2xl overflow-hidden border border-border">
            <iframe title="map" data-testid="contact-map" className="w-full h-56 grayscale contrast-125 opacity-80"
              src="https://www.openstreetmap.org/export/embed.html?bbox=-79.92%2C43.49%2C-79.83%2C43.55&layer=mapnik" />
          </div>
        </div>

        <div id="quote-form" className="scroll-mt-28">
          <QuoteForm className="glass rounded-3xl p-8" />
        </div>
      </div>
    </section>
  );
}
